import { Create_profiles_for_personalised_advertising, Measure_advertising_performance, Store_and_or_access_information_on_a_device, Understand_audiences_through_statistics_or_combinations_of_data_from_different_sources, Use_limited_data_to_select_advertising, Use_profiles_to_select_personalised_advertising, } from "@trinitymirrordigital/consent-helper/iab-gvl";
import { Amazon_Advertising, Criteo_SA, GumGum_Inc, Improve_Digital, Index_Exchange_Inc, Insticator_Inc, LiveRamp, Magnite_Inc, Rich_Audience_Technologies_SLU, Taboola_Europe_Limited, The_Ozone_Project_Limited, Triple_Lift_Inc, Xandr_Inc, } from "@trinitymirrordigital/consent-helper/iab-gvl";
export const REQUIRED_PURPOSES = [
    Store_and_or_access_information_on_a_device,
    Use_limited_data_to_select_advertising,
    Create_profiles_for_personalised_advertising,
    Use_profiles_to_select_personalised_advertising,
    Measure_advertising_performance,
    Understand_audiences_through_statistics_or_combinations_of_data_from_different_sources,
];
export const REQUIRED_VENDORS = {
    Amazon: [Amazon_Advertising],
    Magnite: [Magnite_Inc, Xandr_Inc, Triple_Lift_Inc],
    LiveRamp: [LiveRamp],
    Prebid: [
        Criteo_SA,
        GumGum_Inc,
        Improve_Digital,
        Index_Exchange_Inc,
        Insticator_Inc,
        Rich_Audience_Technologies_SLU,
        Taboola_Europe_Limited,
        The_Ozone_Project_Limited,
        Xandr_Inc,
    ],
};
